import styled from "styled-components";

const S = {
    Overlay: styled.div`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        backdrop-filter: blur(5px);
        animation: fadeIn 0.4s ease;

        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
    `,
    PopupContainer: styled.div`
        position: relative;
        background: white;
        width: 90%;
        max-width: 450px;
        border-radius: 24px;
        padding: 40px;
        text-align: center;
        box-shadow: 0 20px 40px rgba(0,0,0,0.2);
        animation: slideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1);

        @keyframes slideUp {
            from { transform: translateY(50px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
        }
    `,
    CloseButton: styled.button`
        position: absolute;
        top: 15px;
        right: 15px;
        background: #f1f5f9;
        border: none;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #64748b;
        transition: all 0.2s ease;

        &:hover {
            background: #e2e8f0;
            color: #0f172a;
            transform: scale(1.1);
        }

        svg {
            width: 20px;
            height: 20px;
        }
    `,
    IconWrapper: styled.div`
        background: #25D366;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 25px;
        box-shadow: 0 10px 25px rgba(37, 211, 102, 0.4);
        
        svg {
            width: 45px;
            height: 45px;
            fill: white;
        }
    `,
    Title: styled.h3`
        font-size: 1.6em;
        color: #0f172a;
        margin: 0 0 15px 0;
        font-weight: 700;
    `,
    Text: styled.p`
        font-size: 1.1em;
        color: #475569;
        margin: 0 0 30px 0;
        line-height: 1.6;
    `,
    WhatsappButton: styled.a`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #25D366;
        color: white;
        text-decoration: none;
        padding: 16px 30px;
        border-radius: 50px;
        font-weight: 600;
        font-size: 1.15em;
        width: 100%;
        box-sizing: border-box;
        transition: all 0.3s ease;
        box-shadow: 0 8px 20px rgba(37, 211, 102, 0.3);

        &:hover {
            background: #1ebc5a;
            transform: translateY(-3px);
            box-shadow: 0 12px 25px rgba(37, 211, 102, 0.4);
        }
    `
};
export default S;
